/**
 * Vehicle Add-ons & Upgrades Modal Controller (Zero-Pricing & Direct Line-Item Properties)
 */
(function () {
  'use strict';

  class VehicleAddonsModal {
    constructor(modalEl) {
      this.modal = modalEl;
      this.sectionId = this.modal.dataset.sectionId;
      this.productInfo = document.getElementById(`MainProduct-${this.sectionId}`) || document.querySelector(`product-info[data-section="${this.sectionId}"]`);
      this.productForm = this.productInfo ? this.productInfo.querySelector('product-form') : null;

      // Elements
      this.dialog = this.modal.querySelector('.addons-modal__dialog');
      this.closeBtns = this.modal.querySelectorAll('[data-addons-modal-close]');
      
      this.upgradeCards = this.modal.querySelectorAll('.addons-upgrade-card');
      this.checkboxes = this.modal.querySelectorAll('.addon-item-card__checkbox');

      this.deliveryCard = this.modal.querySelector('#AddonsDeliveryLabel');
      this.deliveryCheckbox = this.modal.querySelector('#AddonsDeliveryCheckbox');
      this.deliveryPostcodeField = this.modal.querySelector('#AddonsDeliveryPostcodeField');
      this.deliveryPostcodeInput = this.modal.querySelector('#AddonsDeliveryPostcode');

      this.otherInput = this.modal.querySelector('#AddonsOtherText');

      this.vehicleBasePriceEl = this.modal.querySelector('[data-vehicle-base-price]');
      this.summaryVehiclePriceEl = this.modal.querySelector('[data-summary-vehicle-price]');
      this.summaryAddonsCountEl = this.modal.querySelector('[data-summary-addons-count]');
      this.summaryTotalPriceEl = this.modal.querySelector('[data-summary-total-price]');

      this.btnVehicleOnly = this.modal.querySelector('[data-addons-action="vehicle-only"]');
      this.btnWithAddons = this.modal.querySelector('[data-addons-action="with-addons"]');

      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

      this.init();
    }

    init() {
      this.bindEvents();
      this.interceptProductSubmit();
      this.updateCounts();
    }

    bindEvents() {
      // Close modal events
      this.closeBtns.forEach((btn) => {
        btn.addEventListener('click', () => this.close());
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.modal.classList.contains('is-active')) {
          this.close();
        }
      });

      // Interactive Upgrade Cards
      this.upgradeCards.forEach((card) => {
        const cb = card.querySelector('.addon-item-card__checkbox');
        if (!cb) return;

        card.addEventListener('click', (e) => {
          if (e.target === cb) return;
          e.preventDefault();
          cb.checked = !cb.checked;
          card.classList.toggle('is-checked', cb.checked);
          this.updateCounts();
        });

        cb.addEventListener('change', () => {
          card.classList.toggle('is-checked', cb.checked);
          this.updateCounts();
        });
      });

      // Nationwide Delivery Card
      if (this.deliveryCard && this.deliveryCheckbox) {
        this.deliveryCard.addEventListener('click', (e) => {
          if (e.target === this.deliveryCheckbox) return;
          e.preventDefault();
          this.deliveryCheckbox.checked = !this.deliveryCheckbox.checked;
          this.handleDeliveryToggle();
        });

        this.deliveryCheckbox.addEventListener('change', () => {
          this.handleDeliveryToggle();
        });
      }

      // Other Text Input
      if (this.otherInput) {
        this.otherInput.addEventListener('input', () => {
          this.updateCounts();
        });
      }

      // Action buttons
      if (this.btnVehicleOnly) {
        this.btnVehicleOnly.addEventListener('click', () => this.handleAddVehicleOnly());
      }

      if (this.btnWithAddons) {
        this.btnWithAddons.addEventListener('click', () => this.handleAddWithAddons());
      }
    }

    handleDeliveryToggle() {
      if (!this.deliveryCheckbox) return;
      const isChecked = this.deliveryCheckbox.checked;
      if (this.deliveryCard) {
        this.deliveryCard.classList.toggle('is-checked', isChecked);
      }
      if (this.deliveryPostcodeField) {
        this.deliveryPostcodeField.style.display = isChecked ? 'block' : 'none';
        if (isChecked && this.deliveryPostcodeInput) {
          this.deliveryPostcodeInput.focus();
        }
      }
      this.updateCounts();
    }

    updateCounts() {
      let count = 0;
      this.checkboxes.forEach((cb) => {
        if (cb.checked) count++;
      });
      if (this.deliveryCheckbox && this.deliveryCheckbox.checked) {
        count++;
      }
      if (this.otherInput && this.otherInput.value.trim() !== '') {
        count++;
      }

      if (this.summaryAddonsCountEl) {
        this.summaryAddonsCountEl.textContent = count;
      }
    }

    interceptProductSubmit() {
      if (!this.productForm) return;

      const mainSubmitButton = this.productForm.querySelector('[type="submit"]');
      if (!mainSubmitButton) return;

      // Intercept the click on Main Add To Cart button
      mainSubmitButton.addEventListener('click', (e) => {
        if (mainSubmitButton.getAttribute('aria-disabled') === 'true' || mainSubmitButton.hasAttribute('disabled')) {
          return;
        }

        // Open modal instead of immediately submitting
        e.preventDefault();
        e.stopPropagation();
        this.syncVehicleDetails();
        this.open();
      }, true);
    }

    syncVehicleDetails() {
      if (!this.productInfo) return;

      const priceElement = this.productInfo.querySelector('.price-item--regular, .price-item--sale, .price__regular .price-item');
      if (priceElement && this.vehicleBasePriceEl) {
        const displayedPrice = priceElement.textContent.trim();
        if (displayedPrice) {
          this.vehicleBasePriceEl.textContent = displayedPrice;
          if (this.summaryVehiclePriceEl) {
            this.summaryVehiclePriceEl.textContent = displayedPrice;
          }
          if (this.summaryTotalPriceEl) {
            this.summaryTotalPriceEl.textContent = displayedPrice;
          }
        }
      }
    }

    open() {
      this.modal.classList.add('is-active');
      this.modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('overflow-hidden');
      if (this.dialog) {
        this.dialog.focus();
      }
    }

    close() {
      this.modal.classList.remove('is-active');
      this.modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('overflow-hidden');
    }

    setButtonLoading(button, isLoading) {
      if (!button) return;
      button.classList.toggle('is-loading', isLoading);
      const spinner = button.querySelector('.addons-modal__btn-spinner');
      if (spinner) {
        spinner.classList.toggle('hidden', !isLoading);
      }
      if (isLoading) {
        button.setAttribute('disabled', 'disabled');
      } else {
        button.removeAttribute('disabled');
      }
    }

    async handleAddVehicleOnly() {
      this.setButtonLoading(this.btnVehicleOnly, true);
      try {
        const variantId = this.getMainVariantId();
        const quantity = this.getMainQuantity();

        if (!variantId) {
          throw new Error('Vehicle variant not selected.');
        }

        const response = await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: parseInt(variantId, 10),
                quantity: parseInt(quantity, 10)
              }
            ]
          })
        });

        const addData = await response.json();
        if (addData.status && addData.status >= 400) {
          throw new Error(addData.description || addData.message || 'Error adding vehicle to cart.');
        }

        const sectionsData = await this.fetchCartSections();
        this.close();
        this.handlePostAddSuccess(sectionsData, addData);
      } catch (err) {
        console.error('Error adding vehicle only:', err);
        alert(err.message || 'Could not add vehicle to cart. Please try again.');
      } finally {
        this.setButtonLoading(this.btnVehicleOnly, false);
      }
    }

    async handleAddWithAddons() {
      this.setButtonLoading(this.btnWithAddons, true);
      try {
        const mainVariantId = this.getMainVariantId();
        const quantity = this.getMainQuantity();

        if (!mainVariantId) {
          throw new Error('Vehicle variant not selected.');
        }

        // Collect all selected upgrades
        const selectedUpgrades = [];
        this.checkboxes.forEach((cb) => {
          if (cb.checked && cb.value) {
            selectedUpgrades.push(cb.value);
          }
        });

        // Collect delivery request
        const deliveryRequested = this.deliveryCheckbox ? this.deliveryCheckbox.checked : false;
        const deliveryPostcode = this.deliveryPostcodeInput ? this.deliveryPostcodeInput.value.trim() : '';

        // Collect other request
        const otherText = this.otherInput ? this.otherInput.value.trim() : '';

        // Build line-item properties
        const properties = {};
        if (selectedUpgrades.length > 0) {
          properties['Selected Upgrades'] = selectedUpgrades.join(', ');
        }
        if (otherText) {
          properties['Other Upgrades'] = otherText;
        }
        if (deliveryRequested) {
          properties['Nationwide Delivery Requested'] = 'Yes (Quote upon contact)';
          if (deliveryPostcode) {
            properties['Delivery Postcode'] = deliveryPostcode;
          }
        }

        const response = await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: parseInt(mainVariantId, 10),
                quantity: parseInt(quantity, 10),
                properties: properties
              }
            ]
          })
        });

        const addData = await response.json();
        if (addData.status && addData.status >= 400) {
          throw new Error(addData.description || addData.message || 'Error adding items to cart.');
        }

        const sectionsData = await this.fetchCartSections();
        this.close();
        this.handlePostAddSuccess(sectionsData, addData);
      } catch (err) {
        console.error('Error adding vehicle with upgrades:', err);
        alert(err.message || 'Could not add items to cart. Please try again.');
      } finally {
        this.setButtonLoading(this.btnWithAddons, false);
      }
    }

    async fetchCartSections() {
      try {
        const url = `${window.routes?.cart_url || '/cart'}?sections=cart-drawer,cart-icon-bubble`;
        const res = await fetch(url);
        return await res.json();
      } catch (e) {
        console.error('Error fetching cart sections:', e);
        return null;
      }
    }

    handlePostAddSuccess(sectionsData, addData) {
      const cartDrawerEl = document.querySelector('cart-drawer');

      if (cartDrawerEl) {
        if (cartDrawerEl.classList.contains('is-empty')) {
          cartDrawerEl.classList.remove('is-empty');
        }
        const innerEmpty = cartDrawerEl.querySelector('.drawer__inner-empty');
        if (innerEmpty) {
          innerEmpty.classList.add('hidden');
        }

        if (sectionsData && typeof cartDrawerEl.renderContents === 'function') {
          cartDrawerEl.renderContents({
            id: addData?.id || (addData?.items && addData.items[0]?.id),
            sections: sectionsData
          });
        } else {
          if (sectionsData && sectionsData['cart-drawer']) {
            const parsed = new DOMParser().parseFromString(sectionsData['cart-drawer'], 'text/html');
            const newCartDrawer = parsed.querySelector('#CartDrawer');
            const currentCartDrawer = document.getElementById('CartDrawer');
            if (newCartDrawer && currentCartDrawer) {
              currentCartDrawer.innerHTML = newCartDrawer.innerHTML;
            }
          }
          if (sectionsData && sectionsData['cart-icon-bubble']) {
            const bubble = document.getElementById('cart-icon-bubble');
            if (bubble) {
              bubble.innerHTML = new DOMParser().parseFromString(sectionsData['cart-icon-bubble'], 'text/html').querySelector('.shopify-section')?.innerHTML || sectionsData['cart-icon-bubble'];
            }
          }
          if (typeof cartDrawerEl.open === 'function') {
            cartDrawerEl.open();
          }
        }
      } else {
        window.location.href = window.routes?.cart_url || '/cart';
      }

      // Publish PubSub event if Dawn pubsub system exists
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'addons-modal',
          cartData: addData
        });
      }
    }

    getMainVariantId() {
      const input = this.productInfo ? this.productInfo.querySelector('input[name="id"]') : null;
      return input ? input.value : null;
    }

    getMainQuantity() {
      const qtyInput = this.productInfo ? this.productInfo.querySelector('input[name="quantity"]') : null;
      return qtyInput ? qtyInput.value : 1;
    }
  }

  // Initialize modals on DOM ready and dynamic Shopify section loads
  function initAddonsModals() {
    const modals = document.querySelectorAll('.addons-modal');
    modals.forEach((modal) => {
      if (!modal._vehicleAddonsInitialized) {
        modal._vehicleAddonsInitialized = new VehicleAddonsModal(modal);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAddonsModals);
  } else {
    initAddonsModals();
  }

  document.addEventListener('shopify:section:load', initAddonsModals);
})();
